module.exports = __webpack_public_path__ + "img/dalina_lopez.d78ffb96.png";